import api from "./api";

const getErrorMessage = (error, fallback) =>
  error?.response?.data?.message || error?.message || fallback;

const withApiResult = async (request, fallbackMessage) => {
  try {
    const response = await request();
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: getErrorMessage(error, fallbackMessage) };
  }
};

export const getAllUsers = () =>
  withApiResult(() => api.get("/users"), "Failed to fetch users");

export const getUserById = (userId) =>
  withApiResult(() => api.get(`/users/${userId}`), "Failed to fetch user");

export const updateUser = (userId, userData) =>
  withApiResult(() => api.put(`/users/${userId}`, userData), "Failed to update user");

export const updateUserStatus = (userId, isActive) =>
  withApiResult(
    () => api.put(`/users/${userId}/status`, { isActive }),
    "Failed to update user status"
  );

export const updateUserRole = (userId, role) =>
  withApiResult(
    () => api.put(`/users/${userId}/role`, { role }),
    "Failed to update user role"
  );

export const deleteUser = (userId) =>
  withApiResult(() => api.delete(`/users/${userId}`), "Failed to delete user");

export const updateUserProfile = (userData) =>
  withApiResult(() => api.put("/users/profile", userData), "Failed to update user profile");
